/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  IBundler3,
  IBundler3Interface,
} from "../../../../contracts/periphery/MorphoBundler3Unwrapper.sol/IBundler3";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "skipRevert",
            type: "bool",
          },
          {
            internalType: "bytes32",
            name: "callbackHash",
            type: "bytes32",
          },
        ],
        internalType: "struct IBundler3.Call[]",
        name: "",
        type: "tuple[]",
      },
    ],
    name: "multicall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
] as const;

export class IBundler3__factory {
  static readonly abi = _abi;
  static createInterface(): IBundler3Interface {
    return new Interface(_abi) as IBundler3Interface;
  }
  static connect(address: string, runner?: ContractRunner | null): IBundler3 {
    return new Contract(address, _abi, runner) as unknown as IBundler3;
  }
}
